const PagesCodes = Object.freeze({
    AboutUs: "about-us",
    ContactUs: "contact-us",
    Home: "home",
    Languages: "languages",
    OurClients: "clients",
    OurPartners: "partners",
    FAQ: "faqs",
    SEOSettings: "seo-settings",
    TermsAndConditions: "terms-conditions",
    ReviewsPage: "reviews",
    AcademicIntegrity : "academic-integrity",
    RemotePolicy : "remote-teaching-policy",
    RightsProtection : "property-rights-protection",
    SupportPolicy: "technical-support-policy",
    Complians : "complains",
    Company: 'company-services',
    AttendancePolicy: 'attendance-policy',
    CommunicationPolicy: 'communication-policy',
    PrivacyPolicy: 'privacy-policy',
});

export default PagesCodes;
